module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("Chapter One")]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _vm._v("Early Years")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("R")]), _vm._v("einhard Heydrich is regarded as one of the darkest figures in the Nazi hierarchy. He joined the Nazi Party in June 1931 and by August that same year had joined the realms of the SS. During this time Heinrich Himmler, leader of the SS, began setting up a counter-intelligence section of the SS and met Heydrich for an informal meeting at a railway station in Eberstein. Himmler was so impressed with Heydrich’s ideas that he hired him straight away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heydrich began his role as chief of the new ‘Ic Service’ (Intelligence Service) from the Nazi Party head office in Munich called the Brown House. Within weeks of taking the job he had formed a large network of spies and informers. By December Himmler had promoted him to the rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SS-Sturmbannführer.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-1932 Himmler appointed Heydrich as chief of the renamed security service: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sicherheitsdienst")]), _vm._v(" (Security Service or SD). Consequently, Heydrich’s power grew over the next couple of years, turning a small counter-intelligence department into an efficient machine of fear and intimidation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By June 1934 Heydrich had become head of the Gestapo, which he used as an instrument of terror against his opponents. Over the next couple of years the Gestapo earned its infamous reputation with its policemen using torture and violence as their key to interrogation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In June 1936 Hitler decreed the unification of all police forces in Germany and named Himmler as Chief of German Police. With this appointment Himmler and his deputy Heydrich became the most powerful and feared men in Germany. Himmler immediately restructured and organized the police, with Heydrich having the security agencies separated into two groups comprising the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ordnungspolizei")]), _vm._v(" (Order Police or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orpo")]), _vm._v("), consisting of the national uniformed police and the municipal police plus the Security Police. The Security Police was made up of the combined forces of the Gestapo and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kriminalpolizei")]), _vm._v(" (Criminal Police or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kripo")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Heydrich now at the zenith of his power he became the chief enforcer of Nazi terror inside Germany. He was able to widen his network of fear to persecute more and more groups including unionists, intellectuals, liberal priests, Seventh-Day Adventists, sexual minorities, gypsies and, the most reviled people in his eyes, the Jews.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Following the Anschluss in Austria in March 1938, under the direction of the SS Heydrich then formed one of the most fearsome of all the groups under his control known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzgruppen")]), _vm._v(" (deployment forces or task forces). They were created from an ad hoc "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzkommando")]), _vm._v(" and were responsible for securing government buildings and documents. Originally these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzkommandos")]), _vm._v(" were part of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sicherheitspolizei")]), _vm._v(" (Security Police or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SiPo")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that year, when the Sudetenland was assigned to Germany between 1 and 10 October 1938, Heydrich ordered two units of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Einsatzgruppen")]), _vm._v(" to be moved to the region and given the task of removing all government papers and police documents. They were also ordered to surround and raid the government buildings and detain and question senior civil servants, which included the arrest of more than 10,000 Czech communists and German citizens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During this time Heydrich was also tasked to deport Jews out of Germany, during which operation he used every method possible, including a nationwide pogrom, to terrify Jews into leaving. His actions included what later became known as ‘the Night of Broken Glass’ ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kristallnacht")]), _vm._v(") on 9/10 November 1938. More than 1,000 synagogues and 7,000 Jewish businesses had been attacked. More than 90 people had been murdered and 30,000 Jews were arrested and sent to concentration camps. To further intimidate the Jewish people, it was Heydrich who proposed that Jews should be forced to wear a signifying mark such as a yellow star on their clothes, but Hitler refused at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the coming months while the Jews were continually mistreated and intimidated, the German war machine prepared itself for war against Poland. Although Heydrich had immense powers within the Nazi State at this time, his purview was still initially limited to internal policing. However, as preparations against Poland were being made, his power would swiftly expand. ")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A postcard showing a swastika flag flying over the Brown House, the Nazi Party headquarters in Munich.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Reinhard Heydrich handing a piece of paper to Alfred Naujocks in April 1934 from his desk at his Brown House headquarters in Munich. Naujocks was initially a low-ranking driver for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sicherheitsdienst")]), _vm._v(" SD-Regional Command East, Berlin in 1934, but Heydrich soon entrusted him with special assignments such as murder.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Two photographs showing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SS-Brigadeführer")]), _vm._v(" Heydrich working at his desk from his Brown House headquarters in Berlin in 1934. During this period he was head of the Bavarian Police and chief of the SD.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A photograph of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geheimes Staatspolizeihauptamt,")]), _vm._v(" or Gestapo headquarters, which was at 8 Prinz Albrecht Street in Berlin. On 22 April 1934 Heydrich was appointed head of the Gestapo by Himmler. Both men employed young and highly-educated officers into the Gestapo, which had a wide variety of academic fields. Heydrich in particular looked for candidates that were hard-working, efficient and prepared to carry the Nazi state forward through the persecution of their political opponents. As a result, the Gestapo immediately became an instrument of terror under SS control.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A portrait photograph of Heydrich as commander of the Gestapo. As soon as Heydrich was appointed to his new position he began building the Gestapo into an instrument of fear. Under his complete control he had the authority to arrest citizens on suspicion that they might commit a crime, and the definition of a crime was at his discretion.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Heydrich sitting on some steps with his sword following a memorial service. In 1935 Himmler began developing the concept of a new religion known as the Germanic religion. He wanted all SS members to leave the church. In early 1936, Heydrich left the Catholic Church in favour of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gottglaubig")]), _vm._v(" movement.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Himmler with Heydrich visits the preparations for the memorial service of Reich President Paul von Hindenburg. This was known as the Tannenberg Memorial, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tannenberg-Nationaldenkmal,")]), _vm._v(" and was a monument to the German soldiers of the Battle of Tannenberg, the First Battle of the Masurian Lakes and the medieval Battle of Tannenberg in 1410. The victorious German commander General Field Marshal von Hindenburg, who became a national hero, was later interred there on site. A memorial service was held in honour of him and the battle, of which the SS played a big part in marking.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Heydrich is in the centre of a group of German police officials during a visit to the tomb of the unknown soldier.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Himmler and Heydrich are seen here climbing some steps. By mid-June 1936, all police forces throughout Germany were united and Himmler was made Chief of German Police. With this appointment by Hitler, Himmler and his deputy Heydrich became two of the most powerful men in the internal administration of the Reich.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Heydrich can be seen to the left of Himmler with an Italian fascist delegation.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Heydrich and other SS officers with their wives in 1937.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Leaving his hotel with Heydrich in Vienna, both Himmler and Heydrich can be seen here in front of the Hotel Metropol in Vienna after the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anschluss")]), _vm._v(" of Austria on 12 March 1938. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Himmler can be seen here attending a swearing ceremony of the Austrian Police in March 1938 on Heldenplatz in Vienna. Heydrich can just be seen within the entourage walking behind the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichsführer.")]), _vm._v(" With the unification of Germany and Austria, Himmler and Heydrich quickly ordered the suppression of all opposition. In fact, even before the first German soldier crossed the border, both men began arresting prominent representatives of those they regarded would be hostile to the Reich.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A still taken from a film showing Hitler, Himmler and Heydrich together during a ceremony.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Arthur Seyss-Inquart, Adolf Hitler, Heinrich Himmler and Heydrich in Vienna in March 1938. In February 1938, Seyss-Inquart was appointed Austrian Minister of the Interior by Schuschnigg after Hitler had threatened Schuschnigg with military actions against Austria in the event of non-compliance. Just weeks later Seyss-Inquart drafted the legislative act reducing Austria to a province of Germany and signed it into law on 13 March. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Himmler and Heydrich can be seen here climbing some steps at Prague Castle. By the late 1930s Heydrich was at the peak of his power and became the chief enforcer of Nazi terror inside Germany. With his vast chain of contacts and police network he was able to widen his net of fear and persecute more and more groups, all of which were in his mind ‘hostile elements of the Reich’.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0020-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("At a luncheon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SS-Obergruppenführer")]), _vm._v(" Werner Best is seen with a representative of the Hungarian police in Berlin in February 1939. Heydrich made Best head of Amt I (Department I) of the RSHA: Administration and Legal. It was a department that dealt with the legal and personnel issues/matters of the SS and security police. Both Heydrich and Himmler relied on Best to develop and explain legally the activities against enemies of the state and in relation to the Nazi Jewish policy. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bbb528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 75
// module chunks = 0